<template>
    <div>

    <div class="accordion-container" :class="isClosed ? '' : 'show-less'">
        <div class="accordion-header" @click="handleClosed">
            <img src="/images/new_branding/pack-garantie.png" class="gift-icon">
            <div>
                <h2 class="pack-pretitle">Gegarandeerde gemoedsrust</h2>
                <h3 class="pack-title">Slechts 2€. <br>
                    Makkelijk opzegbaar</h3>
            </div>
            <span :class="['accordion-btn', 'show-more', { 'is-open': !isClosed }]"></span>
        </div>
    </div>
        <div class="form-pack">
            <div :class="isClosed ? 'is-closed' : ''" class="accordion-body">
                <div class="pack-iban">
                    <p>Het heeft geen zin om tegen je zin lid te blijven van Testaankoop. Dankzij onze tevredenheidsgarantie ben je vrij om je abonnement stop te zetten wanneer je dat wenst. Je verwittigt ons ten laatste 15 werkdagen voor het einde van elke maandelijkse vervaldag*.</p>
                    <p>Er is dus geen enkele aankoopverplichting en je bent ons geen verklaring verschuldigd.</p>
                    <p>*Opgelet: elke begonnen maand wordt beschouwd als een volledige maand.</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import image_mixin from "./mixins/image_mixin";

export default {
    name: "PackComponentAccordionIban",
    mixins: [
        image_mixin
    ],
    computed: {
        isIban() {
            return this.$store.get('general_data/current_step') === 'iban'
        }
    },
    data() {
        return {
            isClosed: true,
        };
    },
    methods: {
        handleClosed() {
            this.isClosed = !this.isClosed;
        },
    },
    mounted() {
        // console.log('test store',(this.$store.get('general_data/current_step' === 'iban')))

    }
}
</script>

<style lang="scss" scoped>

</style>
